module.exports = __webpack_public_path__ + "img/doc-acpt.3a1d7a97.svg";